import { ProductModel } from '@/product/entity/Product';

import {
  ProductType,
  TYPE_DIAMOND_FANCY,
  TYPE_GEM,
  TYPE_JEWELRY,
  TYPE_LGD_ROUGH,
  TYPE_ROUGH,
} from '../constants/productTypes';

import Diamond, { DiamondModel } from './Diamond';
import Gem, { GemModel } from './Gem';
import Jewelry from './Jewelry';
import Rough from './Rough';

export default class ProductFactory {
  static make(productType: ProductType, productData: ProductModel) {
    if (productType === TYPE_ROUGH || productType === TYPE_LGD_ROUGH) {
      return new Rough(productData);
    }

    if (productType === TYPE_JEWELRY) {
      return new Jewelry(productData);
    }

    if (productType === TYPE_GEM) {
      return new Gem(productData as GemModel);
    }

    const diamond = new Diamond(productData as DiamondModel);

    if (productType === TYPE_DIAMOND_FANCY) {
      diamond.isFancyColor = true;
    }

    return diamond;
  }
}
